import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	employeeCount   : 0,
	employeePending : false,
	employeeDes     : [],
	employeeDep     : [],
	employeeList    : { active: [], pending: [], reject: [], managers: [], alert: true }
};

export const employeeslice = createSlice({
	name     : 'employee',
	initialState,
	reducers : {
		updateEmployeeData : (state, action) =>
		{
			state.employeeCount = action.payload;
		},
		updateEmployeePending : (state, action) =>
		{
			state.employeeCount = action.payload;
		},
		updateEmployeeDes : (state, action) =>
		{
			state.employeeDes = action.payload;
		},
		updateEmployeeDep : (state, action) =>
		{
			state.employeeDep = action.payload;
		},
		getEmployeeRedux : (state, action) =>
		{
			state.employeeList = { ...state.employeeList, ...action.payload };
		}
	}
});

export const { updateEmployeeData, updateEmployeeDes,
	updateEmployeeDep, getEmployeeRedux } = employeeslice.actions;
export default employeeslice.reducer;